import type {
  Query,
  PathOptions,
  Path,
  PagedListQuery,
  PagedListRequestOptionsNoQuery,
  PagedListOptions
} from './types'

interface CreateQueryResult {
  fields?: string
  expand?: string
  [filter: string]: any
}

export const createQuery = (query: Query) => {
  const result: CreateQueryResult = {}

  for (const key in query) {
    if (key === 'fields') {
      result.fields = query.fields?.join(',')
    } else if (key === 'expand') {
      result.expand = query.expand?.join(',')
    } else if (query[key]) {
      result[key] = query[key]
    }
  }

  return result
}

interface CreateListQueryResult extends CreateQueryResult {
  page?: number
  'per-page'?: number
  limit?: string | number
}

export const createPagedListQuery = (
  options: PagedListOptions,
  requestOptions: PagedListRequestOptionsNoQuery,
  query: PagedListQuery
) => {
  const result: CreateListQueryResult = {}

  for (const key in query) {
    if (key === 'fields') {
      result.fields = query.fields?.join(',')
    } else if (key === 'expand') {
      result.expand = query.expand?.join(',')
    } else if (key === 'page') {
      if (
        requestOptions.pagination &&
        options.paginationType === 'page' &&
        query.page > 1
      ) {
        result.page = query.page
      }
    } else if (key === 'perPage') {
      if (requestOptions.pagination) {
        if (options.paginationType === 'page') {
          result['per-page'] = query.perPage
        } else {
          result.limit = query.perPage
        }
      }
    } else if (query[key]) {
      result[key] = query[key]
    }
  }

  return result
}

export const createUrl = (path: Path, query: Query, options: PathOptions) =>
  typeof path === 'function' ? path(query, options) : path
